/**
 * @module client
 *
 */

function isMobileMiddlewareSupported() {
  return navigator.userAgent.indexOf('MobileMiddlewareSupported') >= 0;
}

function createHiddenInput() {
  if (!window.document || !window.document.body) {
    return;
  }
  const inputElement = window.document.createElement('input');
  inputElement.style.display = 'none';

  window.document.body.appendChild(inputElement);

  return inputElement;
}

function printWindow() {
  // @ts-ignore: Fixed in TypeScript 2.8.2
  window.print();
}

function handleMobileAppPrint() {
  const input = createHiddenInput();
  if (!input) {
    return;
  }

  input.select();
  printWindow();
  input.remove();
}

export function handleAppPrint() {
  if (isMobileMiddlewareSupported()) {
    handleMobileAppPrint();
  } else {
    printWindow();
  }
}



// WEBPACK FOOTER //
// ./src/client/print.ts